import { Component, OnInit, Inject } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from '../services/client.service';
import { MethodService } from '../services/method.service';
import { MachineService } from '../services/machine.service';
import { IndicatorService } from '../services/indicator.service';
import { ProductService } from '../services/product.service';
import { SubjectService } from '../services/subject.service';
import { GroupService } from '../services/group.service';
import { EmployeeService } from '../services/employee.service';
import { RequestService } from '../services/request.service';
import { SettingsService } from '../services/settings.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PackageService } from '../services/package.service';
import { TechniciansService } from '../services/technicians.service';
import { ServiceService } from '../services/service.service';

export interface DeleteModal {
  id: number;
  component: string;
}

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css']
})
export class ModalsComponent implements OnInit {
  id: number;
  component: string;
  ngOnInit() {
  }
  closeResult: string;

  constructor(private modalService: NgbModal,
    // public activeModal: NgbActiveModal,
    private clientService: ClientService,
    private methodService: MethodService,
    private machineService: MachineService,
    private indicatorService: IndicatorService,
    private productService: ProductService,
    private subjectService: SubjectService,
    private groupService: GroupService,
    private employeeService: EmployeeService,
    private requestService: RequestService,
    private packageService: PackageService,
    private technicianService: TechniciansService,
    private serviceService: ServiceService,
    public dialogRef: MatDialogRef<ModalsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteModal,
    private settingService: SettingsService) {

  }

  closeModal() {
    this.dialogRef.close();

  }

  deleteRecord(id, component) {
    switch (component) {
      case 'client':
        this.clientService.deleteClient(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'method':
        this.methodService.deleteMethod(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'machine':
        this.machineService.deleteMachine(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'indicator':
        this.indicatorService.deleteIndicator(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'product':
        this.productService.deleteProduct(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'subject':
        this.subjectService.deleteSubject(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'account':
        this.subjectService.deleteAccount(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'group':
        this.groupService.deleteGroup(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'employee':
        this.employeeService.deleteEmployee(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'request':
        this.requestService.deleteRequest(id).subscribe(data => {
          this.dialogRef.close(component);
        });

        break;
      case 'ips':
        this.settingService.deleteIp(id).subscribe(data => {
          this.dialogRef.close(component);
        });
        break;
      case 'package':
        this.packageService.deletePackage(id).subscribe(data => {
          this.dialogRef.close(component);
        });
        break;
      case 'technician':
        this.technicianService.deleteTechnicians(id).subscribe(data => {
          this.dialogRef.close(component);

        });
        break;
      case 'service':
        this.serviceService.deleteService(id).subscribe(data => {
          this.dialogRef.close(component);
        });
        break;


      default:
        break;
    }

  }

}
